import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { buildFilterUrl, extractSearchQuery } from '@/creditflowresearch/ui/common/utils/query/buildFilterUrl';
import { QUERY_PARAMS_TO_REMOVE } from '@/creditflowresearch/ui/common/utils/query/filterQueryConstants';

interface IUseFilterNavigationOptions {
  paramsToRemove?: string[],
}

interface INavigateToFilterResult {
  newUrl: string,
  searchQuery: string,
}

interface IUseFilterNavigationResult {
  navigateToFilter: (filterKey: string, filterValue: string) => INavigateToFilterResult,
  buildFilterUrl: (filterKey: string, filterValue: string) => string,
}

export const useFilterNavigation = ({
  paramsToRemove = QUERY_PARAMS_TO_REMOVE,
}: IUseFilterNavigationOptions = {}): IUseFilterNavigationResult => {
  const { query, asPath } = useRouter();

  const buildFilterUrlForNavigation = useCallback((filterKey: string, filterValue: string): string => {
    return buildFilterUrl({
      query,
      asPath,
      filterKey,
      filterValue,
      paramsToRemove,
    });
  }, [query, asPath, paramsToRemove]);

  const navigateToFilter = useCallback((filterKey: string, filterValue: string): INavigateToFilterResult => {
    const newUrl = buildFilterUrlForNavigation(filterKey, filterValue);
    const searchQuery = extractSearchQuery(newUrl);

    return { newUrl, searchQuery };
  }, [buildFilterUrlForNavigation]);

  return {
    navigateToFilter,
    buildFilterUrl: buildFilterUrlForNavigation,
  };
};
